/**
 * Share Dialog Functionality.
 */

import { openDialog, closeDialog } from './share/components/dialog.js';
//import { observeStickyAd } from './share/components/sticky-ad.js';
import { setupCopyLink } from './share/components/copy-link.js';
import { createOutsideClickListener } from './share/components/outside-click.js';

/**
 * Initialize the share dialog functionality.
 *
 * This function sets up event listeners for the share button, close button,
 * and handles the copy link functionality. It also observes changes to the
 * sticky ad element to adjust the dialog position accordingly.
 */
document.addEventListener( 'DOMContentLoaded', function() {
	const shareButton = document.getElementById( 'shareButton' );
	const shareDialog = document.getElementById( 'shareDialog' );
	const closeShare = document.getElementById( 'closeShare' );
	const copyLinkButton = document.getElementById( 'copyLinkButton' );

	// If the share dialog or button is not found, exit early.
	if ( ! shareDialog || ! shareButton || ! closeShare || ! copyLinkButton ) {
		return;
	}

	// Ensure sticky ad element is observed.
	//observeStickyAd( shareDialog );

	// Create an outside click listener to close the dialog when clicking outside.
	const outsideClickListener = createOutsideClickListener(
		shareDialog,
		shareButton,
		() => closeDialog( shareDialog, shareButton, outsideClickListener )
	);

	// Add event listeners for the share button and close button.
	shareButton.addEventListener( 'click', ( e ) => {
		e.stopPropagation();
		if ( shareDialog.hasAttribute( 'open' ) ) {
			closeDialog( shareDialog, shareButton, outsideClickListener );
		} else {
			openDialog( shareDialog, shareButton, outsideClickListener );
		}
	});

	// Close the dialog when the close button is clicked.
	closeShare.addEventListener( 'click', () => closeDialog( shareDialog, shareButton, outsideClickListener ) );

	// Close the dialog when the Escape key is pressed.
	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && shareDialog.hasAttribute( 'open' ) ) {
			closeDialog( shareDialog, shareButton, outsideClickListener );
		}
	});

	// Set up the copy link functionality.
	if ( ! copyLinkButton ) {
		return;
	}

	setupCopyLink( copyLinkButton );

	// Detect if user has resized the window and close share dialog if it is open.
	window.addEventListener( 'resize', () => {
		if ( shareDialog.hasAttribute( 'open' ) ) {
			closeDialog( shareDialog, shareButton, outsideClickListener );
		}
	} );
} );
